import type { ReportBlock } from '@/lib/types/report'
import { Markdown } from '@/components/chat/Markdown'

export function MarkdownBlock({ block }: { block: ReportBlock }) {
  return (
    <div className="report-prose max-w-[70ch]">
      <Markdown>{String(block.data.content_md ?? '')}</Markdown>
    </div>
  )
}
